import { FeaturedStoriesSectionData } from './type'

export const featuredStoriesSectionData: FeaturedStoriesSectionData = {
  headline: 'Stories That Celebrate What Matters',
  tagline: 'From everyday adventures to once-a-year celebrations — personalised with your child',
  ctaText: 'View All Products',
  ctaLink: '/shop',
  stories: [
    {
      id: 1,
      title: 'Before You Could Remember',
      imageUrl: '/images/stories/before-you-could-remember/cover.webp',
      tag: 'Mother\'s Day',
      href: '/shop/mothers-day-letter',
    },
    {
      id: 2,
      title: 'A Hug for Punch',
      imageUrl: '/images/stories/a-hug-for-punch/cover.webp',
      tag: 'New',
      href: '/shop/punch-the-monkey',
    },
    {
      id: 3,
      title: 'Five Autumns for You',
      imageUrl: '/images/stories/five-autumns-for-you/cover.webp',
      tag: 'Birthday',
      href: '/shop/fifth-birthday-easter',
      comingSoon: true,
    },
  ],
}
